<template>
  <loading-view :loading="isLoading">
    <truncate-view
      v-if="currentContent"
      v-model="previewMode"
      class="editor-minimal readonly relative my-4 z-0">
      <editor-wrapper :initial-data="currentContent.data" readonly />
    </truncate-view>
    <error-view :error="error" v-if="error" title="" />
  </loading-view>
</template>

<script setup lang="ts">
import EditorWrapper from "/js/components/utilities/Editor/EditorWrapper.vue"
import type { ContentWidget } from "/js/components/BlockBuilder/Widget"
import { useQuery } from "@tanstack/vue-query"
import { computed, ref } from "vue"
import ErrorView from "/js/components/utilities/UI/ErrorView.vue"
import { WidgetsApi } from "/js/services/WidgetsApi"
import TruncateView from "/js/components/utilities/TruncateView.vue"
import LoadingView from "/js/components/LoadingView.vue"

const props = defineProps<{
  widget: ContentWidget
  widgetId: string
}>()

const previewMode = ref(props.widget.display_type === "preview")

const {
  data: editorContents,
  isLoading,
  error,
} = useQuery({
  queryKey: computed(() => ["content_widget_full_items", props.widgetId]),
  queryFn: async () => await WidgetsApi.getEditorContentFullItems(props.widgetId),
})

// this needs to be converted into a paged cards widget, but there's a problem with the difference in height between contents
// so we hardcode it to 1 for now
const currentContent = computed(() => editorContents.value?.[0])

</script>

<script lang="ts">
export default {
  name: "ContentCard",
}
</script>
